import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { config } from "../config";

export const msalConfig: Configuration = {
  auth: {
    clientId: config.LANDING_PAGE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common/',
    redirectUri: config.LANDING_PAGE_REDIRECT_URL
  },
  cache: {
    cacheLocation: 'localStorage'
  }
}

export const authConfig = {
  scopes: config.LANDING_PAGE_SCOPE
}

export const auth = new PublicClientApplication(msalConfig);
auth.initialize().then(() => {
  auth.handleRedirectPromise().then((res) => {
    console.log(res);
    if (res) {
      auth.setActiveAccount(res.account);
    }
  }).catch((err) => {
    console.log(err);
  })
});